<template>
  <v-row noGutters>
    <v-col v-if="localData" cols="auto">
      <v-sheet width="350">
        <toolbar-view title="Фильтры"/>
        <v-sheet :height="height-48" class="overflow-y-auto px-4 pt-2" color="transparent">
          <com-branch-autocomplete-multiple :select.sync="localData.data.filter.comBranchs"/>
          <spec-autocomplete-multiple :select.sync="localData.data.filter.specs"/>
          <user-autocomplete-multiple
              :name="'Специалисты ('+(localData.data.filter.userspecsExclude ? 'исключить' : 'включить')+')'"
              :select.sync="localData.data.filter.userspecs"
              _type="spec"
          >
            <template v-slot:appendOuter>
              <tooltip bottom>
                <v-btn
                    @click="localData.data.filter.userspecsExclude=!localData.data.filter.userspecsExclude"
                    :class="localData.data.filter.userspecsExclude ? 'v-btn--active' : ''"
                    icon class="mt-n2"
                >
                  <v-icon>mdi-playlist-remove</v-icon>
                </v-btn>
                <template v-slot:content>
                  Исключить выбор
                </template>
              </tooltip>
            </template>
          </user-autocomplete-multiple>
          <v-autocomplete
              label="Статус визита"
              v-model="localData.data.filter.statuses"
              :items="visitStatuses"
              outlined
              dense
              hide-details="auto"
              multiple
              class="mb-4"
              item-text="name"
              item-value="id"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Не найдено</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item="{item}">
              <v-list-item-title>
                <div class="py-2">
                  <v-avatar :color="item.color" size="12" class="mr-2"/>
                  {{ item.name }}
                </div>
              </v-list-item-title>
            </template>
            <template v-slot:selection="{item}">
              <v-chip class="full-width mt-2" small style="width:95%">
                <v-row no-gutters>
                  <v-col cols="auto">
                    <v-avatar :color="item.color" class="circleIcon mr-2"/>
                  </v-col>
                  <v-col class="text-overflow">{{ item.name }}</v-col>
                  <v-col cols="auto">
                    <v-icon small @click.stop="localData.data.filter.statuses=localData.data.filter.statuses.filter((v)=>v!==item.id)">
                      mdi-close-circle
                    </v-icon>
                  </v-col>
                </v-row>
              </v-chip>
            </template>
          </v-autocomplete>
          <date-interval name="Дата визита" :valueFrom.sync="localData.data.filter.visitBegin" :valueTo.sync="localData.data.filter.visitEnd"/>
          <checkbox-field
              name="Первый визит клиента"
              :value.sync="localData.data.filter.visitFirst"
              :disabled="$tools.isEmpty(localData.data.filter.visitBegin) || $tools.isEmpty(localData.data.filter.visitEnd)"
              help="Доступно если точно выбран интервал даты визита"
              class="mb-4"
          />
          <checkbox-field name="Клиент был только вчера" :value.sync="localData.data.filter.lastVisitYesterday" help="Последний визит был вчера, но до этого 9 дней не было визитов" class="mb-4"/>
          <v-select
              label="Последний визит клиента"
              v-model="localData.data.filter.lastVisit"
              clearable
              :items="[
                {name:'В течении 10 дней',value:'within10days'},
                {name:'Ранее 10 дней',value:'earlier10days'},
              ]"
              item-text="name"
              outlined dense hide-details="auto" class="my-4"
          />
          <v-select
              label="Пол клиента"
              v-model="localData.data.filter.gender"
              :items="[
                {name:'Любой',value:null},
                {name:'Мужчина',value:'male'},
                {name:'Женщина',value:'female'},
              ]"
              item-text="name"
              outlined dense hide-details="auto" class="my-4"
          />
          <v-text-field
              label="День рождение клиента"
              v-model="localData.data.filter.birthDay"
              dense outlined hide-details="auto"
              clearable
              class="mt-1 mb-4"
              hint="день и месяц (01.12)"
              v-mask="'##.##'"
          />
          <label-view title="Возраст клиента">
            <template v-slot:content>
              <v-row class="pt-2 px-1 mb-2">
                <v-col>
                  <v-text-field label="С" v-model="localData.data.filter.birthFrom" clearable type="number" hide-details outlined dense/>
                </v-col>
                <v-col>
                  <v-text-field label="По" v-model="localData.data.filter.birthTo" clearable type="number" hide-details outlined dense/>
                </v-col>
              </v-row>
            </template>
          </label-view>
          <tag-autocomplete-multiple name="Теги клиента" :select.sync="localData.data.filter.tags" entityType="user"/>
          <date-interval name="Интервал действия тега клиента" :valueFrom.sync="localData.data.filter.tagDateFrom" :valueTo.sync="localData.data.filter.tagDateTo"/>
        </v-sheet>
      </v-sheet>
    </v-col>
    <v-col cols="auto"><v-divider vertical/></v-col>
    <v-col>
      <v-sheet :width="width-350-1">
        <n-table-view
            ref="table"
            name="Список"
            class="table3 full-width"
            :genRequestBuilder="requestBuilder"
            :height="height"
            :selectAll.sync="selectAll"
            :selectIndeterminate="selectIndeterminate"
            :headers="[
            { text: 'ID', value: 'id', class:'text-no-wrap'},
            { text: 'Дата и время', value: 'begin',  class:'text-no-wrap'},
            { text: 'Статус', value: 'status', class:'text-no-wrap'},
            { text: 'Специалист', value: 'userSpec.user.id',  class:'text-no-wrap'},
            { text: 'Специальность', value: 'userSpec.spec.id',  class:'text-no-wrap'},
            { text: 'Филиал', value: 'comPlace.comRoom.comFloor.comBuilding.comBranch.id',  class:'text-no-wrap'},
            { text: 'Кабинет', value: 'comPlace.comRoom.sid',  class:'text-no-wrap'},
            { text: 'Комментарий', value: 'comment',  class:'text-no-wrap'},
            { text: 'Клиент', value: 'user.lastName',  class:'text-no-wrap'},
            { text: 'Номер мед.карты', value: 'user.userProfile.medCardNumber', class:'text-no-wrap'},
          ]"
        >
          <template v-slot:barActions>
            <v-text-field
                class="d-none"
                :value="localData?.data.selects.length ? '1' : ''"
                :rules="formFieldRules.required"
            />
          </template>
          <template v-slot:item="{ item }">
            <tr @click="visitId=item.id">
              <td>
                <v-checkbox @click.stop="$tools.selectToggle(localData.data.selects, item)" :input-value="$tools.isSelect(localData.data.selects, item)" class="ma-0 pa-0" dense hide-details />
              </td>
              <td class="text-no-wrap">{{item.id}}</td>
              <td class="text-no-wrap">{{$tools.dateTimeFormat(item.begin, 'DD.MM.YYYY')}} в {{$tools.dateTimeFormat(item.begin, 'HH:mm')}}</td>
              <td class="text-no-wrap">
                <visit-status :status="$tools.findById(visitStatuses, item.status)" :isPaidFull="item.paySummary.isPaidFull" :isSecond="item.isSecond" small/>
              </td>
              <td class="text-no-wrap"><UserFullName :user="item.userSpec.user" type="spec" avatar/></td>
              <td class="text-no-wrap">{{ item.userSpec.spec.name }}</td>
              <td class="text-no-wrap">{{ item.comPlace.comRoom.comFloor.comBuilding.comBranch.name }}</td>
              <td class="text-no-wrap">{{ item.comPlace.comRoom.sid }}</td>
              <td class="text-no-wrap">
                <tooltip v-if="!$tools.isEmpty(item.comment)" bottom>
                  {{$tools.truncateText(item.comment,50)}}
                  <template v-slot:content>
                    <div v-html="$tools.nl2br(item.comment)"></div>
                  </template>
                </tooltip>
              </td>
              <td class="text-no-wrap"><UserFullName :user="item.user"/></td>
              <td class="text-no-wrap">{{item.user.userProfile.medCardNumber ? item.user.userProfile.medCardNumber : item.user.id}}</td>
            </tr>
          </template>
        </n-table-view>
      </v-sheet>
      <visit :visitId.sync="visitId"/>
    </v-col>
  </v-row>
</template>

<script>
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import NTableView from "@/componentsV2/base/NTableView.vue";
import {
  Entity_ComBranch,
  Entity_ComBuilding,
  Entity_ComFloor,
  Entity_ComPlace, Entity_ComRoom, Entity_Spec, Entity_Tag, Entity_TagLink,
  Entity_User, Entity_UserProfile, Entity_UserSpec,
  Entity_Visit
} from "../../../../../../EntityStoreCacheService";
import ToolbarView from "@/components/ToolbarView.vue";
import VisitStatus from "@/components/VisitStatus.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import Api from "@/Api";
import SpecAutocompleteMultiple from "@/componentsV2/custom/SpecAutocompleteMultiple.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import LabelView from "@/components/LabelView.vue";
import TagAutocompleteMultiple from "@/componentsV2/custom/TagAutocompleteMultiple.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import moment from "moment";
import Visit from "@/views/Visit/Visit.vue";
import {FormFieldRules} from "@/plugins/formFieldRules";

export default {
  components: {
    Visit,
    CheckboxField,
    DateInterval,
    TagAutocompleteMultiple,
    LabelView,
    UserAutocompleteMultiple,
    ComBranchAutocompleteMultiple,
    SpecAutocompleteMultiple,
    Tooltip, VisitStatus, ToolbarView, NTableView, UserFullName
  },
  props: ['data','width','height'],
  data: () => ({
    localData:null,
    formFieldRules: FormFieldRules,
    visitStatuses:Api.model.Visit.statuses,
    visitId:null,
    items:[],
  }),
  mounted() {
    this.localData = this.data;
  },
  watch: {
    data() {
      this.localData = this.data;
    },
    localData:{
      handler(){
        this.$tools.debounce(()=>{
          if(Object.values(this.localData.data.filter).filter(v=>typeof v!=='undefined').length){
            this.$refs.table.load()
            this.$emit('update', this.localData)
          }
        }, 1000, 'distributeVisitsForm')
      },
      deep: true
    },
    visitId(){
      if(this.visitId===null)
        this.$refs.table.load();
    }
  },
  computed:{
    selectAll:{
      get(){
        if(this.localData===null) return false;
        return this.$tools.isSelectAll(this.items, this.localData.data.selects)
      },
      set(){
        this.$tools.selectAllToggle(this.items, this.localData.data.selects)
      }
    },
    selectIndeterminate:{
      get(){
        if(this.localData===null) return false;
        return this.$tools.isSelectIntermidiate(this.items, this.localData.data.selects)
      },
    },
  },
  methods:{
    requestBuilder(page, onPage, sortFields) {
      let rb = new Entity_Visit()
          .selects(Entity_Visit.id)
          .selects(Entity_Visit.begin)
          .selects(Entity_Visit.end)
          .selects(Entity_Visit.status)
          .selects(Entity_Visit.comment)
          .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.sid].join('.'))
          .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.'))
          .selects([Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.name].join('.'))
          .selects([Entity_Visit.user, Entity_User.id].join('.'))
          .selects([Entity_Visit.user, Entity_User.type].join('.'))
          .selects([Entity_Visit.user, Entity_User.firstName].join('.'))
          .selects([Entity_Visit.user, Entity_User.lastName].join('.'))
          .selects([Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.medCardNumber].join('.'))
          .selects([Entity_Visit.user, Entity_User.secondName].join('.'))
          .selects([Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))
          .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
          .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.type].join('.'))
          .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
          .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
          .selects([Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))
          .virtual(Entity_Visit.virtual_paySummary)
          .filterAnd([Entity_Visit.entity, Entity_Visit.mark].join('.')+' IS NULL')
          .page(page)
          .onPage(onPage)
          .orderFromTable(sortFields)
          .addStateCallback((v) => {
            if(v.success)
              this.items = v.items;
            if (v.error)
              this.$store.commit('alertError', 'Ошибка загрузки данных.Если ошибка повторяется, обратитесь в тех. поддержку');
          })

      if(!this.$tools.isEmpty(this.localData.data.filter.comBranchs)){
        rb.filterAnd(
            [Entity_Visit.entity,Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.comFloor, Entity_ComFloor.comBuilding, Entity_ComBuilding.comBranch, Entity_ComBranch.id].join('.')+ ' IN (?)',
            this.localData.data.filter.comBranchs.map(v=>v.id)
        )
      }
      if(!this.$tools.isEmpty(this.localData.data.filter.specs)){
        rb.filterAnd(
            [Entity_Visit.entity,Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_UserSpec.id].join('.')+ ' IN (?)',
            this.localData.data.filter.specs.map(v=>v.id)
        )
      }
      if(!this.$tools.isEmpty(this.localData.data.filter.userspecs)){
        if(this.localData.data.filter.userspecsExclude){
          rb.filterAnd(
              [Entity_Visit.entity,Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.')+ ' NOT IN (?)',
              this.localData.data.filter.userspecs.map(v=>v.id)
          )
        } else {
          rb.filterAnd(
              [Entity_Visit.entity,Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.')+ ' IN (?)',
              this.localData.data.filter.userspecs.map(v=>v.id)
          )
        }

      }
      if(!this.$tools.isEmpty(this.localData.data.filter.statuses)){
        rb.filterAnd(
            [Entity_Visit.entity,Entity_Visit.status].join('.')+ ' IN (?)',
            this.localData.data.filter.statuses
        )
      }
      if(this.localData.data.filter.visitFirst){
        let arr = [];
        if (this.localData.data.filter.visitBegin)
          arr.push(moment(this.localData.data.filter.visitBegin, 'DD.MM.YYYY').set({hour: 0, minute: 0, second: 0}).format('YYYY-MM-DD HH:mm:ss'));
        if (this.localData.data.filter.visitEnd)
          arr.push(moment(this.localData.data.filter.visitEnd, 'DD.MM.YYYY').set({hour: 23, minute: 59, second: 59}).format('YYYY-MM-DD HH:mm:ss'));

        rb.filterAdd(Entity_Visit.filterAdd_visitFirst, arr.join('|'))
      }

      if (this.localData.data.filter.visitBegin){
        rb.filterAnd(
            [Entity_Visit.entity, Entity_Visit.begin].join('.') + ' >= ?',
            moment(this.localData.data.filter.visitBegin, 'DD.MM.YYYY').set({hour: 0, minute: 0, second: 0})
        )
      }
      if (this.localData.data.filter.visitEnd){
        rb.filterAnd(
            [Entity_Visit.entity, Entity_Visit.begin].join('.') + ' <= ?',
            moment(this.localData.data.filter.visitEnd, 'DD.MM.YYYY').set({hour: 23, minute: 59, second: 59})
        )
      }

      if (this.localData.data.filter.lastVisit){
        if(this.localData.data.filter.lastVisit==='within10days'){
          rb.filterAnd(
              [Entity_Visit.entity,Entity_Visit.user, Entity_User.visits, Entity_Visit.begin].join('.') + '>=?',
              moment().subtract('10', 'days').format('YYYY-MM-DD HH:mm:ss')
          )
          rb.filterAnd(
              [Entity_Visit.entity,Entity_Visit.user, Entity_User.visits, Entity_Visit.status].join('.') + ' IN (?)',
              ['complete']
          )
        } else if(this.localData.data.filter.lastVisit==='earlier10days'){
          rb.filterAnd(
              [Entity_Visit.entity,Entity_Visit.user, Entity_User.visits, Entity_Visit.begin].join('.') + '<?',
              moment().subtract('10', 'days').format('YYYY-MM-DD HH:mm:ss')
          )
          rb.filterAnd(
              [Entity_Visit.entity,Entity_Visit.user, Entity_User.visits, Entity_Visit.status].join('.') + ' IN (?)',
              ['complete']
          )
        }
      }

      if (this.localData.data.filter.lastVisitYesterday){
        rb.filterAdd(Entity_Visit.filterAdd_lastVisitYesterday)
      }


      if(this.localData.data.filter.gender){
        rb.filterAnd(
            [Entity_Visit.entity,Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.gender].join('.')+ '=?',
            this.localData.data.filter.gender
        )
      }
      if(this.localData.data.filter.birthDay) {
        rb.filterAdd(Entity_Visit.filterAdd_birthDay, moment(this.localData.data.filter.birthDay, 'DD.MM').format('DD-MM'))
      }

      if (this.localData.data.filter.birthFrom) {
        rb.filterAnd(
            [Entity_Visit.entity, Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.birth].join('.') + '<?',
            moment().set({hour: 0, minute: 0, second: 0}).subtract(this.localData.data.filter.birthFrom, 'years')
        )
      }
      if (this.localData.data.filter.birthTo) {
        rb.filterAnd(
            [Entity_Visit.entity, Entity_Visit.user, Entity_User.userProfile, Entity_UserProfile.birth].join('.') + '>?',
            moment().set({hour: 0, minute: 0, second: 0}).subtract(this.localData.data.filter.birthTo, 'years')
        )
      }

      if (!this.$tools.isEmpty(this.localData.data.filter.tags)) {
        rb.filterAnd(
            [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.tag, Entity_Tag.id].join('.') + ' IN (?)',
            this.localData.data.filter.tags.map(v => v.id)
        )

        if (this.localData.data.filter.tagDateFrom && this.localData.data.filter.tagDateTo) {
          rb.filterAnd(
              [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.startDate].join('.') + ' <=? AND ' +
              [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.endDate].join('.') + ' >=?'
              , moment(this.localData.data.filter.tagDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59')
              , moment(this.localData.data.filter.tagDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')
          );
        } else if (this.localData.data.filter.tagDateFrom && !this.localData.data.filter.tagDateTo) {
          rb.filterAnd(
              [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.startDate].join('.') + '>=? OR ' +
              [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.endDate].join('.') + ' >=?'
              , moment(this.localData.data.filter.tagDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')
              , moment(this.localData.data.filter.tagDateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00')
          );
        } else if (!this.localData.data.filter.tagDateFrom && this.localData.data.filter.tagDateTo) {
          rb.filterAnd(
              [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.startDate].join('.') + '<=? OR ' +
              [Entity_Visit.entity, Entity_Visit.user, Entity_User.tagLinks, Entity_TagLink.endDate].join('.') + ' <=?'
              , moment(this.localData.data.filter.tagDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59')
              , moment(this.localData.data.filter.tagDateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59')
          );
        }

      }

      return rb;
    },
  }
}
</script>